<p-drawer [(visible)]="colRightIsActive" position="right" styleClass="!w-full md:!w-[40rem]">
  <div class="sidebar h-100">
    <div class="sidebar-content card h-100">
      <div class="card-body h-100">


        <div class="flex flex-wrap justify-between align-items-center">
          <h3 class="text-2xl tracking-[-1px] font-semibold text-gray-900">{{ 'Aide à la Gestion'|transloco }}</h3>
          <editButton
            [routerLink]="['/DOnet', 'mon-reporting-mensuel']"
            [label]="('Accéder à mes Dossiers en J+'|transloco)+JplusBlocked"
            [size]="'sm'"
            [icon]="'pi pi-arrow-right'"
          ></editButton>
        </div>

        <p-accordion [value]="'j35'">
          <p-accordion-panel [value]="'j35'">
            <p-accordion-header>
              <h4 class="text-lg font-semibold text-gray-900"> {{ 'Sinistres à plus de J +'|transloco }}{{JplusBlocked}} </h4>
            </p-accordion-header>
            <p-accordion-content [className]="'pt-4 pb-0 px-0'">

              <p-table
                [value]="listBlocked"
                [scrollable]="true"
                scrollHeight="flex"
                stripedRows
                #dt
              >
                <ng-template #header>
                  <tr>
                    <th></th>
                    <th pResizableColumn pSortableColumn="referencevge">
                      <div class="flex flex-nowrap justify-between align-items-center gap-2">
                        <span>{{ 'Sinistre'|transloco }} <p-sortIcon field="referencevge" /></span>
                        <p-columnFilter type="text" field="referencevge" display="menu" />
                      </div>
                    </th>
                    <th pResizableColumn pSortableColumn="operationLibelle">
                      <div class="flex flex-nowrap justify-between align-items-center gap-2">
                        <span>{{ 'Opération' | transloco }} <p-sortIcon field="operationLibelle" /></span>
                        <p-columnFilter type="text" field="operationLibelle" display="menu" />
                      </div>
                    </th>
                  </tr>
                </ng-template>
                <ng-template #body let-blocked let-rowIndex="rowIndex">
                  <tr>
                    <td>
                      <div class="flex flex-nowrap align-items-center gap-2">
                        <tableEditButton
                          [pTooltip]="'Voir la fiche sinistre ' + blocked?.referencevge"
                          [routerLink]="['/DOnet', 'sinistre', 'fiche', blocked?.sinistreId, blocked?.operationId]"
                          [icon]="'pi pi-folder'"
                        ></tableEditButton>
                        <tableEditButton
                          [pTooltip]="'Ajouter un suivi a ce sinistre'"
                          (click)="openModaleAjoutSuivi(blocked, blocked?.operationId)"
                          [icon]="'fa fa-light fa-envelope'"
                        ></tableEditButton>
                        <tableEditButton
                          [pTooltip]="'Voir l\'historique de ce sinistre'"
                          (click)="openModaleHistorique(blocked)"
                          [icon]="'pi pi-list'"
                        ></tableEditButton>
                      </div>
                    </td>
                    <td>
                      {{blocked?.referencevge}}
                    </td>
                    <td>
                      {{blocked?.operationLibelle}}
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </p-accordion-content>
          </p-accordion-panel>
          <p-accordion-panel [value]="'j27'">
            <p-accordion-header>
              <h4 class="text-lg font-semibold text-gray-900"> {{ 'Sinistres à plus de J +'|transloco }}{{JplusWarning}} </h4>
            </p-accordion-header>
            <p-accordion-content [className]="'pt-4 pb-0 px-0'">

              <p-table
                [value]="listWarning"
                [scrollable]="true"
                scrollHeight="flex"
                stripedRows
                #dt
              >
                <ng-template #header>
                  <tr>
                    <th></th>
                    <th pResizableColumn pSortableColumn="referencevge">
                      <div class="flex flex-nowrap justify-between align-items-center gap-2">
                        <span>{{ 'Sinistre'|transloco }} <p-sortIcon field="referencevge" /></span>
                        <p-columnFilter type="text" field="referencevge" display="menu" />
                      </div>
                    </th>
                    <th pResizableColumn pSortableColumn="operationLibelle">
                      <div class="flex flex-nowrap justify-between align-items-center gap-2">
                        <span>{{ 'Opération' | transloco }} <p-sortIcon field="operationLibelle" /></span>
                        <p-columnFilter type="text" field="operationLibelle" display="menu" />
                      </div>
                    </th>
                  </tr>
                </ng-template>
                <ng-template #body let-warning let-rowIndex="rowIndex">
                  <tr>
                    <td>
                      <div class="flex flex-nowrap align-items-center gap-2">
                        <tableEditButton
                          [pTooltip]="'Voir la fiche sinistre ' + warning?.referencevge"
                          [routerLink]="['/DOnet', 'sinistre', 'fiche', warning?.sinistreId, warning?.operationId]"
                          [icon]="'pi pi-folder'"
                        ></tableEditButton>
                        <tableEditButton
                          [pTooltip]="'Ajouter un suivi a ce sinistre'"
                          (click)="openModaleAjoutSuivi(warning, warning?.operationId)"
                          [icon]="'fa fa-light fa-envelope'"
                        ></tableEditButton>
                        <tableEditButton
                          [pTooltip]="'Voir l\'historique de ce sinistre'"
                          (click)="openModaleHistorique(warning)"
                          [icon]="'pi pi-list'"
                        ></tableEditButton>
                      </div>
                    </td>
                    <td>
                      {{warning?.referencevge}}
                    </td>
                    <td>
                      {{warning?.operationLibelle}}
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </p-accordion-content>
          </p-accordion-panel>
        </p-accordion>
      </div>
    </div>
  </div>
</p-drawer>

@if(showJPlus) {
  <!-- Sidebar J+ -->
  <div
    id="colJ35"
    #colRight
    class="fixed right-0 top-1/3 z-40 transform transition-all -translate-y-1/2 cursor-pointer group"
    [ngClass]="{'-translate-[40rem] z-[1102]': colRightIsActive}"
    (click)="toggleSidebar()"
  >
    <div class="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-l-lg shadow-lg hover:shadow-xl transition-all duration-300 group-hover:scale-105">
      <!-- Handle avec indicateur d'ouverture -->
      <div class="relative px-2 py-4 min-h-[120px] flex flex-col space-y-2 items-center justify-center gap-3">

        <!-- J+ Blocked Section -->
        <div class="flex flex-col items-center gap-1">
          <div class="writing-mode-vertical text-xs font-medium text-gray-600 dark:text-gray-300 transform ">
            J+{{JplusBlocked}}
          </div>
          <div
            class="relative mt-2 inline-flex items-center justify-center min-w-[24px] animate-pulse h-6 px-2 text-xs font-bold text-white bg-red-500 rounded-full shadow-sm rotate-90"
            [pTooltip]="nbJBlocked + ' éléments en J+' + JplusBlocked"
            placement="left"
          >
            {{nbJBlocked}}
          </div>
        </div>

        <!-- Séparateur -->
        <div class="w-6 h-px bg-gray-300 dark:bg-gray-600"></div>

        <!-- J+ Warning Section -->
        <div class="flex flex-col items-center gap-1">
          <div class="writing-mode-vertical text-xs font-medium text-gray-600 dark:text-gray-300 transform ">
            J+{{JplusWarning}}
          </div>
          <div
            class="relative mt-2 inline-flex items-center justify-center min-w-[24px] animate-pulse h-6 px-2 text-xs font-bold text-white bg-yellow-500 rounded-full shadow-sm rotate-90"
            [pTooltip]="nbJWarning + ' éléments en J+' + JplusWarning"
            placement="left"
          >
            {{nbJWarning}}
          </div>
        </div>

        <!-- Icône d'action -->
        <div class="">
          <i class="fa-light fa-chevron-left text-gray-400 dark:text-gray-500 text-sm group-hover:text-gray-600 dark:group-hover:text-gray-300 transition-colors duration-200"
             [class.rotate-180]="colRightIsActive"></i>
        </div>
      </div>
    </div>
  </div>

  <sinistreSlider></sinistreSlider>
}

<style>
.writing-mode-vertical {
  writing-mode: vertical-rl;
  text-orientation: mixed;
}
</style>
